export default __webpack_public_path__ + "static/media/scriberx.053fdd7b.jpg";